<template>
  <div class="noticeWarp">
    <div class="contentTitle">{{showExplaxinInfo ? '讲解说明' : '预约须知'}}</div>
    <div class="noticeDetail" v-html="showExplaxinInfo ? explainInfo : $store.state.ticketDetail.bookingNote"></div>
    <div :class="`buttonConfirm ${readTime && !showExplaxinInfo ? 'gayText' : ''}`" @click="hasRead">已读{{readTime && !showExplaxinInfo ? `(${readTime}s)` : ''}}</div>
  </div>
</template>

<script>

export default {
  data() {
    return {
    };
  },

  props: ['type', 'noticeDetail', 'readTime', 'showExplaxinInfo', 'explainInfo'],

  methods: {
    hasRead() {
      this.$parent.hasRead()
    }
  },

  created() {
    
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.noticeWarp{
  padding: 5%;
  position: fixed;
  top:0;
  height: 95%;
  background-color: #fff;
  width: 90%;
  overflow: scroll;
  text-align: left;
  .contentTitle{
    text-align: center;
    margin-bottom: 0.5rem;
  }
  .noticeDetail{
    font-size: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .gayText{
    opacity: 0.9;
    background: #999;
  }
  .buttonConfirm{
    text-align: center;
  }
}
.pcNoticeWarp{
  padding: 0.2rem 5%;
  .noticeDetail{
    font-size: 0.3rem;
  }
  .contentTitle{
    margin-bottom: 0.2rem;
    font-size: 0.35rem;
  }
  .buttonConfirm{
    font-size: 0.3rem;
    width: 1.5rem;
    height: 0.5rem;
    line-height: 0.5rem;
    margin-top: 0.2rem;
  }
}
</style>
